import { getCurrentProject, getProjectsByUserId, useProjectsStore } from '@modules/projects'

export async function syncProjectAfterCreate(
  workspaceId: string,
  createdProjectId?: string | null | void
): Promise<void> {
  await getProjectsByUserId(workspaceId)
  await getCurrentProject(workspaceId)

  if (useProjectsStore.getState().currentProject) {
    return
  }

  if (!createdProjectId) {
    return
  }

  const projectId = String(createdProjectId)
  const state = useProjectsStore.getState()
  const resolved =
    state.projects.find((project) => project.projectId === projectId) ??
    state.allProjects.find((project) => project.projectId === projectId) ??
    null

  if (resolved) {
    useProjectsStore.getState().setCurrentProject(resolved)
  }
}
